import { render, staticRenderFns } from "./ActivationBriefOverviewRouterView.vue?vue&type=template&id=5e4bca7e&"
import script from "./ActivationBriefOverviewRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefOverviewRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports